<!--
  Copyright (C) 2023 Sber

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

          http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.

  Maintainers:
      Rostislav Kabalin <kabalin2009@yandex.ru>

  Contributors:
      Rostislav Kabalin <kabalin2009@yandex.ru> - 2022
      Vladislav Nefedov <clay.zenx@gmail.com>, Sber - 2024
-->

<template>
  <div v-bind:class="$style.icon">
    <!-- Динамическая вставка картинки -->
    <img v-bind:src="iconSrc" alt="Arch Tech Solutions Logo" />
    <!-- Заглушка на случай ошибки загрузки -->
    <span v-if="!iconSrc">Arch Tech Solutions</span>
  </div>
</template>

<script setup lang="ts">
// Импортируем картинку только при монтировании компонента,
// чтобы избежать увеличения бандла, если компонент не используется
  import { ref, onMounted } from 'vue';
  const iconSrc = ref('');
  onMounted(() => {
    import('./arch.png').then((module) => {
      // Получаем URL картинки из модуля
      iconSrc.value = module.default;
    });
  });
</script>

<style module scoped>
.icon {
  display: inline-block; /* Для корректного позиционирования */
  width: var(--size, 200px); /* Размер можно задавать через CSS-переменную */
}

/* Стилизация картинки */
.icon > img {
  max-width: 100%;
  height: auto;
  vertical-align: middle;
}

/* Стиль заглушки */
.icon > span {
  font-size: 100%; /* Уменьшаем размер текста относительно контейнера */
  color: #666;
}
</style>
